import React from 'react';
import { useLang } from '../../i18n/LangContext';
import { User, Wrench, ClipboardCheck, FileCheck2, Home, MapPin } from 'lucide-react';

const icons = [User, Wrench, ClipboardCheck, FileCheck2, Home, MapPin];

export default function WhyUs() {
  const { t } = useLang();
  return (
    <section className="bg-[#0B0D0F] py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-[#D4AF37] text-xs font-mono tracking-[0.25em] uppercase">{t.whyUs.label}</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mt-3 font-outfit">{t.whyUs.heading}</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.whyUs.items.map((item, i) => {
            const Icon = icons[i] || User;
            return (
              <div key={i} className="bg-[#12151A] rounded-lg border border-white/8 p-6 hover:border-[#D4AF37]/20 transition-colors">
                <div className="w-10 h-10 rounded bg-[#D4AF37]/10 flex items-center justify-center mb-4"><Icon className="w-5 h-5 text-[#D4AF37]" /></div>
                <h3 className="text-white font-semibold mb-2 font-outfit">{item.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
